import { AuthService } from "./../models/auth.service";
import { Component, OnInit, Input, Output, EventEmitter } from "@angular/core";
import { WeGoAuthorizedLink } from "../config";
import { fail } from "assert";
import { Router } from "@angular/router";

@Component({
  selector: "wego-authorized-link",
  template: `<a *ngIf="authorizedLink"  class="cursor-pointer" [ngClass]="LinkModel.cssClass" 
              (click)="RaiseOnClick()">
              <template *ngIf="LinkModel.iconClass">
              <i [ngClass]= "LinkModel.iconClass"></i>&nbsp;
              </template>
              {{ LinkModel.label | translate }}</a>
              <span *ngIf="!authorizedLink && LinkModel && LinkModel.displayElementIfNotAuth">             
              {{ LinkModel.label | translate }}
              </span>
              `
})
export class AuthorizedLinkComponent implements OnInit {
  _linkModel: WeGoAuthorizedLink;
  @Output('onClick') onClick = new EventEmitter();
  authorizedLink: boolean;

  constructor(private authService: AuthService,
    private router: Router, ) { }

  ngOnInit() {
    this.authorizedLink = false;
  }

  private RaiseOnClick() {
    if (this.LinkModel.routerLink) {
      this.router.navigate([this.LinkModel.routerLink]);
    }
    else {
      this.onClick.emit();
    }
  }

  @Input()
  set LinkModel(linkModel: WeGoAuthorizedLink) {
    this._linkModel = linkModel;
    this.IsAuthorizedLink();
  }
  get LinkModel() {
    return this._linkModel;
  }

  private IsAuthorizedLink() {
    if (this.LinkModel) {
      this.authService
        .IsAuthorizeURL(
        this.LinkModel.permissionName,
        this.LinkModel.permissionType,
        this.LinkModel.Entity,
        this.LinkModel.EntityId,
      )
        .subscribe(res => {
          console.log("Authorized Link" + res.data);
          this.authorizedLink = res.data;
        });
    } else {
      this.authorizedLink = false;
    }
  }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/shared/components/autorized-link.component.ts